import LoadScript from 'vue-plugin-load-script';
import Vue from 'vue';

Vue.use(LoadScript);
